import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const baseStyles = ({ theme }) => css`
  svg {
    width: ${theme.iconSizes.kilo};
    margin-top: 1px;
  }
`

export const Button = styled(BaseButton)(baseStyles)
